export const companyMixin = {
    computed: {
        aisPackages() {
            const packages = ['consent_with_transactions', 'only_consent'];

            return packages.map(p => ({
                'name': this.formatAisPackage(p),
                'value': p
            }));
        }
    },
    methods: {
        formatAisPackage(item) {
            item = item.replaceAll('_', ' ')
            return item.charAt(0).toUpperCase() + item.slice(1)
        }
    }
};
